import { ExplorerTracking } from "@/lib/tracking/explorer";
import { STATUS_ASSIGNMENT_OPTIONS } from "../../constants";
import { useOpportunities } from "../../useOpportunity";
import { useAppState } from "@/modules/app/useAppContext";
import { NativeSelect, toast } from "@altimateai/lego";

interface StatusAssignerDropdownProps {
  opportunity_id?: string;
  assignedStatus?: string | null;
  setAssignedStatus: (status: string) => void;
  disableUpdateOnChange?: boolean;
  startDate?: string;
  endDate?: string;
}

interface HandleStatusChangeParams {
  e: string | unknown;
  opportunity_id: string | undefined;
}

const StatusAssignerDropdown = ({
  opportunity_id,
  assignedStatus,
  setAssignedStatus = () => {},
  disableUpdateOnChange = false,
  startDate,
  endDate,
}: StatusAssignerDropdownProps) => {
  const { mutation } = useOpportunities();
  const { mutate } = mutation;
  const { loggedinUser: user } = useAppState();

  const handleStatusChange = ({ e, opportunity_id }: HandleStatusChangeParams) => {
    if (!user?.id) {
      toast({ title: "Error", description: "Please try again later.", variant: "destructive" });
      console.error("User ID not found");
      return;
    }
    ExplorerTracking.opportunityStatusAssigned(opportunity_id ?? "", e as string);
    mutate({
      changes: [
        {
          opportunity_id: opportunity_id ?? "",
          status: e as string,
          owner: undefined,
        },
      ],
      user_id: user.id,
      start_date: startDate ?? "",
      end_date: endDate ?? "",
    });
  };

  return (
    <NativeSelect
      id={`state-assigner`}
      size={"sm"}
      onChange={e => {
        setAssignedStatus(e as string);
        if (!disableUpdateOnChange) {
          handleStatusChange({ e, opportunity_id });
        }
      }}
      // Don't fall back to "active" — the bulk-action caller starts
      // with `assignedStatus = null` and the user clicking "Active"
      // on a dropdown already visually showing "Active" wouldn't fire
      // `onChange` (native select only fires on real value change),
      // so `setAssignedStatus` never runs and Apply submits
      // `status: null` (no-op). Letting the dropdown show its
      // "Status" placeholder until the user picks something means
      // every selection — including "Active" — registers correctly.
      value={assignedStatus ?? undefined}
      options={STATUS_ASSIGNMENT_OPTIONS}
      placeholder="Status"
      className="!al-w-full !al-bg-white"
      variant={"outline"}
      buttonProps={{ "aria-label": "Status" }}
    />
  );
};

export default StatusAssignerDropdown;
